import * as liveStream from './api/live-stream'
import * as menu from './api/menu'
import * as storeUser from './api/store-user'
import * as store from './api/store'
import * as file from './api/file'
import * as tag from './api/tag'
import * as allergen from './api/allergen'

export * as logger from './logger-service'
export * as toast from './toast-service'

export const api = {
  liveStream,
  menu,
  storeUser,
  store,
  file,
  tag,
  allergen
}
